import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';

const tagName = 'div';

register('wm-gridcolumn', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {

          return `<${tagName} wmLayoutGridColumn wmsTransclude ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
